import { BrowserLocaleOptions, filterLocaleStrings, getBrowserLocales } from '@vestico/utils';

const DefaultLanguage = 'en';
export const getResolvedLocale = (language?: string, options?: BrowserLocaleOptions) => {
  if (language && language !== DefaultLanguage) {
    const locale = filterLocaleStrings([language], options)[0];
    if (locale) {
      return locale;
    }
  }

  const locale = getBrowserLocales(options)[0];
  return locale;
};
